/**
 * Yotpo API Rating Logic
 * Fetches and updates product ratings via Yotpo CDN API.
 */

const YOTPO_APP_KEY = '4IUUN8iPcgazPHo186IaRl8tyi3exmKjl7A55K3Y';

/**
 * Initializes Yotpo ratings for a set of elements, a single element, or the entire page.
 * @param {HTMLElement|HTMLElement[]|NodeList} elements - Optional elements to search within.
 */
window.initYotpoRatings = function(elements) {
  const containers = [];
  
  if (elements) {
    if (elements instanceof HTMLElement) {
      // If it's a single element, check if it's the rating itself or contains ratings
      if (elements.classList.contains('yotpo-api-rating')) {
        containers.push(elements);
      } else {
        containers.push(...Array.from(elements.querySelectorAll('.yotpo-api-rating')));
      }
    } else {
      // Handle array-like structures
      const elList = Array.from(elements);
      elList.forEach(el => {
        if (el.classList && el.classList.contains('yotpo-api-rating')) {
          containers.push(el);
        } else if (el.querySelectorAll) {
          containers.push(...Array.from(el.querySelectorAll('.yotpo-api-rating')));
        }
      });
    }
  } else {
    containers.push(...Array.from(document.querySelectorAll('.yotpo-api-rating')));
  }

  containers.forEach(container => {
    if (container.hasAttribute('data-yotpo-loaded')) return;
    
    const productId = container.getAttribute('data-yotpo-product-id');
    if (!productId) return;

    container.setAttribute('data-yotpo-loaded', 'true');
    fetchYotpoRating(productId, container);
  });

  // Also trigger Yotpo V3 widgets initialization if they exist on the page
  if (window.yotpo && typeof window.yotpo.initWidgets === 'function') {
    window.yotpo.initWidgets();
  }
};

/**
 * Fetch rating from Yotpo API
 */
async function fetchYotpoRating(productId, container) {
  try {
    const url = `https://api-cdn.yotpo.com/products/${YOTPO_APP_KEY}/${productId}/bottomline`;
    const response = await fetch(url);
    
    if (!response.ok) {
      console.error(`[Yotpo API Rating] Error for ${productId}: Status ${response.status}`);
      return;
    }

    const data = await response.json();

    if (data && data.status && data.status.code === 200) {
      const bottomline = data.response.bottomline;
      updateRatingUI(container, bottomline.average_score, bottomline.total_reviews);
    }
  } catch (error) {
    console.error(`[Yotpo API Rating] Fetch Error for ${productId}:`, error);
  }
}

/**
 * Update the rating UI with fetched data
 */
function updateRatingUI(container, score, count) {
  if (!count || count === 0) {
    container.style.display = 'none';
    return;
  }

  container.style.display = 'inline-flex';
  const starsContainer = container.querySelector('.yotpo-api-rating__stars');
  const scoreContainer = container.querySelector('.yotpo-api-rating__score');
  const separatorContainer = container.querySelector('.yotpo-api-rating__separator');
  const countContainer = container.querySelector('.yotpo-api-rating__count');

  if (scoreContainer) {
    scoreContainer.textContent = score % 1 === 0 ? score : score.toFixed(1);
  }

  if (countContainer) {
    countContainer.textContent = `${count} Reviews`;
  }

  if (starsContainer) {
    const stars = starsContainer.querySelectorAll('.yotpo-api-rating__star');
    stars.forEach((star, index) => {
      const starNum = index + 1;
      star.classList.remove('full', 'half', 'empty');
      
      if (score >= starNum) {
        star.classList.add('full');
      } else if (score >= starNum - 0.5) {
        star.classList.add('half');
      } else {
        star.classList.add('empty');
      }
    });
  }
}

// Initial initialization
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => window.initYotpoRatings());
} else {
  window.initYotpoRatings();
}

// Polling fallback (kept for extreme cases)
let pollCount = 0;
const pollInterval = setInterval(() => {
  window.initYotpoRatings();
  pollCount++;
  if (pollCount > 10) clearInterval(pollInterval);
}, 500);

// MutationObserver to catch any dynamically added ratings automatically
const yotpoObserver = new MutationObserver((mutations) => {
  let shouldInit = false;
  mutations.forEach(mutation => {
    if (mutation.addedNodes.length) {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1 && (node.classList.contains('yotpo-api-rating') || node.querySelector('.yotpo-api-rating'))) {
          shouldInit = true;
        }
      });
    }
  });
  if (shouldInit) window.initYotpoRatings();
});

yotpoObserver.observe(document.body, { childList: true, subtree: true });
